module.exports = __webpack_public_path__ + "static/media/br-ma.4424a9ef.svg";